import React from "react";
import { LandingPageLayout } from "../shared/layout";
import { ThreeBackground } from "./ThreeBackground";
import { Hero } from "./Hero";
import { HowItWorks } from "./HowItWorks";
import { Features } from "./Features";
import { Downloads } from "./Downloads";
import { Testimonials } from "./Testimonials";
import { CTASection } from "./CTASection";

export function LandingPageScreen() {
  return (
    <LandingPageLayout>
      <div className="relative min-h-screen bg-gradient-to-b from-slate-900 via-purple-900 to-slate-900">
        {/* Three.js Background */}
        <ThreeBackground />
        
        {/* Main Content */}
        <div className="relative z-10">
          <Hero />
          <HowItWorks />
          <Features />
          <Downloads />
          <Testimonials />
          <CTASection />
        </div>
      </div>
    </LandingPageLayout>
  );
}
